import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icon/wechat.svg';
import _imports_1 from '../../assets/icon/wework.svg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-09427122"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "success"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "success-icon"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconxuanzhong"
  })], -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "scan-tip"
  }, "注册成功", -1);
});

var _hoisted_4 = /*#__PURE__*/_createTextVNode("进入产品");

var _hoisted_5 = {
  class: "switch-method"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    id: "wxLoginWrapper",
    class: "wxlogin-wrapper"
  }, null, -1);
});

var _hoisted_7 = {
  class: "right"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }), /*#__PURE__*/_createElementVNode("span", null, "扫码绑定企业微信，便于快捷登录")], -1);
});

var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "right"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_1
  }), /*#__PURE__*/_createElementVNode("span", null, "扫码绑定企业微信，便于快捷登录")], -1);
});

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" 返回 ");

var _hoisted_13 = {
  key: 1,
  class: "bind-wechart-tip"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "scan-tip bind-tip"
  }, "扫码绑定", -1);
});

var _hoisted_15 = [_hoisted_14];
var _hoisted_16 = {
  key: 2
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "scan-tip"
  }, "扫码登录", -1);
});

var _hoisted_18 = {
  class: "switch-method"
};

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "微信", -1);
});

var _hoisted_21 = [_hoisted_19, _hoisted_20];

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1
  }, null, -1);
});

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "企业微信", -1);
});

var _hoisted_24 = [_hoisted_22, _hoisted_23];
var _hoisted_25 = {
  id: "wxLoginWrapper",
  class: "wxlogin-wrapper"
};
var _hoisted_26 = ["src"];
var _hoisted_27 = {
  key: 3,
  class: "tip-text"
};
var _hoisted_28 = {
  key: 4,
  class: "tip-text"
};
var _hoisted_29 = {
  key: 2,
  class: "link-wrap"
};

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "还没有账号？", -1);
});

var _hoisted_31 = /*#__PURE__*/_createTextVNode("立即注册");

import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { useStore } from 'vuex';
import { getCookie, isMobile, getDeviceWidth } from '@/utils/index';
import UserService from '@/api/user';
import { getAuthRedirectUrl, getUrlQuery, genHrefOpenUrlNoDecode } from '@/utils/login';
import { wxLoginBindTip, externalBindFailMap } from '@/config/constant';
import { get } from 'lodash';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _loginConfig$methods;

    var loginConfig = window.AppConfig.login;
    var _window$AppConfig$reg = window.AppConfig.register,
        forceBind = _window$AppConfig$reg.forceBind,
        canReturn = _window$AppConfig$reg.canReturn,
        _window$AppConfig$reg2 = _window$AppConfig$reg.hideEntry,
        hideEntry = _window$AppConfig$reg2 === void 0 ? false : _window$AppConfig$reg2;
    var menuMap = window.AppConfig.header.menuMap; // 是否有账密登陆

    var hasAccountLogin = loginConfig === null || loginConfig === void 0 ? void 0 : (_loginConfig$methods = loginConfig.methods) === null || _loginConfig$methods === void 0 ? void 0 : _loginConfig$methods.includes('account');
    var isMobileDevice = isMobile();
    var deviceWidth = getDeviceWidth();
    var route = useRoute();
    var router = useRouter();
    var store = useStore();
    var nameError = ref('');
    var hasLogin = ref(false);
    var frAccountSet = ref(false);
    var wxBindKey = ref('');
    var qywxBindKey = ref('');
    var bindChannel = ref('');
    var bindStatus = ref(0);
    var redirectUrl = ref('');
    var pageFrom = ref('');
    var wxStatus = ref('');
    var loginMethod = ref('wechat');
    var wechatWorkUrl = ref('');
    var wxAppId = computed(function () {
      return store.state.auth.wxAppId;
    });
    var qywxAppId = computed(function () {
      return store.state.auth.qywxAppId;
    });
    var showSkipBind = computed(function () {
      return hasLogin.value && !forceBind && !frAccountSet.value;
    }); // 进入产品

    var goCompanyPage = function goCompanyPage() {
      router.push(menuMap.companyList);
    }; // 获取微信登录key


    var getWxLoginKey = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(loginChannel) {
        var _data$data;

        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return UserService.getWxloginKey({
                  loginChannel: loginChannel,
                  data_auth_redirect_url: getAuthRedirectUrl(route.query),
                  needLoginParam: get(route.query, 'needLoginParam') !== 'false',
                  ap_bind_redirect_url: "".concat(location.origin, "/account/bind")
                });

              case 2:
                data = _context.sent;
                return _context.abrupt("return", ((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.result) || '');

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getWxLoginKey(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var initWxLogin = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var loginRedirectUrl, registerRedirectUrl, key, redirectUri, realRedirectUri, loginStyle;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loginRedirectUrl = window.AppConfig.login.wechatRedirectUrl;
                registerRedirectUrl = window.AppConfig.register.wechatRedirectUrl;

                if (!wxBindKey.value) {
                  _context2.next = 6;
                  break;
                }

                _context2.t0 = wxBindKey.value;
                _context2.next = 9;
                break;

              case 6:
                _context2.next = 8;
                return getWxLoginKey('WX');

              case 8:
                _context2.t0 = _context2.sent;

              case 9:
                key = _context2.t0;
                redirectUri = wxBindKey.value ? registerRedirectUrl : loginRedirectUrl;
                realRedirectUri = "".concat(location.origin).concat(redirectUri, "?key=").concat(key);
                loginStyle = showSkipBind.value ? 'https://resource.growth.qq.com/dataauth/thirdparty/css/wxlogin-small.css' : 'https://resource.growth.qq.com/dataauth/thirdparty/css/wxlogin.css';
                new WxLogin({
                  self_redirect: false,
                  id: 'wxLoginWrapper',
                  appid: wxAppId.value,
                  scope: 'snsapi_login,snsapi_userinfo',
                  // todo: 外网微信
                  redirect_uri: realRedirectUri,
                  state: getCookie('Datatalk-Token'),
                  style: 'black',
                  href: loginStyle
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function initWxLogin() {
        return _ref2.apply(this, arguments);
      };
    }(); // 获取企微登录key


    var getExternalLoginKey = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(loginChannel) {
        var _get, _data$data2;

        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return UserService.getQywxloginKey({
                  loginChannel: loginChannel,
                  dataAuthRedirectUrl: getAuthRedirectUrl(route.query),
                  needLoginParam: get(route.query, 'needLoginParam') !== 'false',
                  apBindRedirectUrl: "".concat(location.origin, "/account/bind"),
                  ap_bind_redirect_url: "".concat(location.origin, "/wxlogin"),
                  corp_invitation_code: ((_get = get(route.query, 'corpInvitationCode')) === null || _get === void 0 ? void 0 : _get.toString()) || ''
                });

              case 2:
                data = _context3.sent;
                return _context3.abrupt("return", ((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.result) || '');

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getExternalLoginKey(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    var initWeworkLogin = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var weworkRedirectUrl, key, weWorkRedirectUri, result, loginStyle;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                weworkRedirectUrl = window.AppConfig.login.weworkRedirectUrl;
                key = qywxBindKey.value;
                weWorkRedirectUri = encodeURIComponent("".concat(location.origin).concat(weworkRedirectUrl, "?key=").concat(key));

                if (key) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 6;
                return getExternalLoginKey('QYWX');

              case 6:
                result = _context4.sent;
                key = result.key;
                weWorkRedirectUri = result.redirectUrl;

              case 9:
                loginStyle = showSkipBind.value ? 'https://resource.growth.qq.com/dataauth/thirdparty/css/wework-login-small.css' : 'https://resource.growth.qq.com/dataauth/thirdparty/css/wework-login.css';
                wechatWorkUrl.value = "https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=".concat(qywxAppId.value, "&usertype=member&redirect_uri=").concat(weWorkRedirectUri, "&state=").concat(key, "&referer=").concat(location.origin, "&href=").concat(loginStyle);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function initWeworkLogin() {
        return _ref4.apply(this, arguments);
      };
    }(); // 外网绑定失败时，弹出错误提示


    var popBindFailTip = function popBindFailTip() {
      if (bindStatus.value) {
        ElMessage({
          message: externalBindFailMap["".concat(bindStatus.value)],
          type: 'error'
        });
      } // 从微信绑定页出错跳转过来


      if (bindChannel.value === 'WX' && wxLoginBindTip["".concat(wxStatus.value)]) {
        ElMessage({
          message: wxLoginBindTip["".concat(wxStatus.value)],
          type: 'error'
        });
      }
    };
    /**
     * 页面使用场景：
     * 1. 微信/企微快捷登录
     * 2. 注册后，绑定快捷登录，UI上通过【是否强制绑定】区分外网和tob版本
     * 3. 点击个人账户设置 - 快捷登录 - 绑定
     */


    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var _route$query, _route$query2, _route$query3, _route$query3$redirec, _route$query4, _route$query4$status, _route$query5, _route$query5$from, _route$query6, _route$query6$status;

      var _route$query7, _route$query7$key, _route$query8, _route$query8$key;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              hasLogin.value = !!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.haslogin);
              bindChannel.value = (_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.loginChannel;
              redirectUrl.value = ((_route$query3 = route.query) === null || _route$query3 === void 0 ? void 0 : (_route$query3$redirec = _route$query3.redirect_url) === null || _route$query3$redirec === void 0 ? void 0 : _route$query3$redirec.toString()) || '';
              bindStatus.value = ((_route$query4 = route.query) === null || _route$query4 === void 0 ? void 0 : (_route$query4$status = _route$query4.status) === null || _route$query4$status === void 0 ? void 0 : _route$query4$status.toString()) || ''; // account:个人设置页

              pageFrom.value = ((_route$query5 = route.query) === null || _route$query5 === void 0 ? void 0 : (_route$query5$from = _route$query5.from) === null || _route$query5$from === void 0 ? void 0 : _route$query5$from.toString()) || '';
              wxStatus.value = ((_route$query6 = route.query) === null || _route$query6 === void 0 ? void 0 : (_route$query6$status = _route$query6.status) === null || _route$query6$status === void 0 ? void 0 : _route$query6$status.toString()) || '';
              frAccountSet.value = pageFrom.value === 'account';
              loginMethod.value = bindChannel.value && bindChannel.value !== 'WX' ? 'wework' : 'wechat';
              _context5.next = 10;
              return store.dispatch('auth/getAppConfig');

            case 10:
              if (loginMethod.value === 'wechat') {
                wxBindKey.value = ((_route$query7 = route.query) === null || _route$query7 === void 0 ? void 0 : (_route$query7$key = _route$query7.key) === null || _route$query7$key === void 0 ? void 0 : _route$query7$key.toString()) || '';
                initWxLogin();
              }

              if (loginMethod.value === 'wework' || !bindChannel.value) {
                qywxBindKey.value = ((_route$query8 = route.query) === null || _route$query8 === void 0 ? void 0 : (_route$query8$key = _route$query8.key) === null || _route$query8$key === void 0 ? void 0 : _route$query8$key.toString()) || '';
                initWeworkLogin();
              }

              popBindFailTip();

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));

    var goLogin = function goLogin() {
      location.href = genHrefOpenUrlNoDecode("/login".concat(getUrlQuery(route.query, 'from=wxlogin')));
    };

    var goRegister = function goRegister() {
      var key = ['redirect_url', 'login_req_key', 'user_info_key', 'corpInvitationCode'];
      var paramStr = key.reduce(function (acc, item) {
        var query = route.query[item] ? "".concat(acc.indexOf('?') > -1 ? '&' : '?').concat(item, "=").concat(route.query[item]) : '';
        return acc + query;
      }, '');
      router.push("".concat(menuMap.register).concat(paramStr));
    };

    var goAccountPage = function goAccountPage() {
      if (frAccountSet.value) {
        router.push(menuMap.account);
      } else {
        router.push("".concat(menuMap.register).concat(getUrlQuery(route.query)));
      }
    };

    var switchMethod = function switchMethod(val) {
      loginMethod.value = val;

      if (val === 'wechat') {
        var _route$query9, _route$query9$key;

        wxBindKey.value = ((_route$query9 = route.query) === null || _route$query9 === void 0 ? void 0 : (_route$query9$key = _route$query9.key) === null || _route$query9$key === void 0 ? void 0 : _route$query9$key.toString()) || '';
        initWxLogin();
      } else {
        var _route$query10, _route$query10$key;

        qywxBindKey.value = ((_route$query10 = route.query) === null || _route$query10 === void 0 ? void 0 : (_route$query10$key = _route$query10.key) === null || _route$query10$key === void 0 ? void 0 : _route$query10$key.toString()) || '';
        initWeworkLogin();
      }
    };

    var goAppPage = function goAppPage() {
      router.push("".concat(location.origin, "/company/list"));
    };

    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", {
        class: "wxlogin",
        style: _normalizeStyle({
          width: _unref(isMobileDevice) ? "".concat(_unref(deviceWidth), "px") : '100%'
        })
      }, [_unref(showSkipBind) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['form-wrapper', 'can-skip', _unref(isMobileDevice) && 'form-wrapper-mobile'])
      }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createVNode(_component_el_button, {
        class: "submit-button",
        type: "primary",
        onClick: goCompanyPage
      }, {
        default: _withCtx(function () {
          return [_hoisted_4];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: _normalizeClass(["method", {
          selected: loginMethod.value === 'wechat'
        }])
      }, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("p", {
        class: "switch",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return switchMethod('wework');
        })
      }, "切换企业微信")])], 2), _createElementVNode("div", {
        class: _normalizeClass(["method", {
          selected: loginMethod.value === 'wework'
        }])
      }, [loginMethod.value === 'wework' ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        class: "qr-code",
        src: wechatWorkUrl.value,
        sandbox: "allow-scripts allow-top-navigation allow-same-origin",
        frameborder: "0",
        width: "96px",
        height: "96px"
      }, null, 8, _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("p", {
        class: "switch",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return switchMethod('wechat');
        })
      }, "切换微信")])], 2)])], 2)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['form-wrapper', _unref(isMobileDevice) && 'form-wrapper-mobile'])
      }, [hasLogin.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "text",
        class: "link-button skip",
        onClick: goAccountPage
      }, {
        default: _withCtx(function () {
          return [_hoisted_12];
        }),
        _: 1
      })) : _createCommentVNode("", true), hasLogin.value && frAccountSet.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
        class: _normalizeClass(["method", {
          selected: loginMethod.value === 'wechat'
        }]),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return switchMethod('wechat');
        })
      }, _hoisted_21, 2), _createElementVNode("div", {
        class: _normalizeClass(["method", {
          selected: loginMethod.value === 'wework'
        }]),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return switchMethod('wework');
        })
      }, _hoisted_24, 2)])])), _withDirectives(_createElementVNode("div", _hoisted_25, null, 512), [[_vShow, loginMethod.value === 'wechat']]), _withDirectives(_createElementVNode("iframe", {
        class: "qr-code",
        src: wechatWorkUrl.value,
        sandbox: "allow-scripts allow-top-navigation allow-same-origin",
        frameborder: "0",
        width: "100%",
        height: "260"
      }, null, 8, _hoisted_26), [[_vShow, loginMethod.value === 'wework']]), frAccountSet.value && loginMethod.value === 'wechat' ? (_openBlock(), _createElementBlock("p", _hoisted_27, " 微信扫码绑定，便于快捷登录 ")) : _createCommentVNode("", true), frAccountSet.value && loginMethod.value === 'wework' ? (_openBlock(), _createElementBlock("p", _hoisted_28, " 企业微信扫码绑定，便于快捷登录 ")) : _createCommentVNode("", true), _unref(hasAccountLogin) && !hasLogin.value ? (_openBlock(), _createElementBlock("div", {
        key: 5,
        class: "switch-login",
        onClick: goLogin
      })) : _createCommentVNode("", true)], 2)), !_unref(hideEntry) && !frAccountSet.value && !_unref(showSkipBind) ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createVNode(_component_el_button, {
        type: "text",
        class: "link-button",
        onClick: goRegister
      }, {
        default: _withCtx(function () {
          return [_hoisted_31];
        }),
        _: 1
      })])) : _createCommentVNode("", true)], 4);
    };
  }
});